export default "__VITE_ASSET__gxjrKqqT__"